import React from 'react'
import {StripeBG, Icon} from '../../../components'
import {Navbar, BlogPost} from '../../../components/marketing'

class PostTestTerms extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="BlogPostPage">
        <StripeBG bg2={"white"} style="purple"/>
        <Navbar className="grid-restrain"/>
        <BlogPost title="So many testing terms, so little time?">
          <p>People get really mixed up with web development testing terms. Let’s try to straighten this out:</p>
          <ul>
            <li><strong><em>Unit</em></strong>&#8202;—&#8202;Test each individual piece of code.</li>
            <li><strong><em>Integration</em></strong>&#8202;—&#8202;Test many pieces of code together.</li>
            <li><strong><em>Functional</em></strong>&#8202;—&#8202;Integration tests that focus on business requirements.</li>
            <li><strong><em>Regression</em></strong>&#8202;—&#8202;Test if a change didn’t break anything that worked previously.</li>
            <li><strong><em>Smoke/Sanity</em></strong>&#8202;—&#8202;Test that it doesn’t just blow up immediately.</li>
            <li><strong><em>Acceptance</em></strong>&#8202;—&#8202;Test done by an actual end user.</li>
          </ul>
          <p>All of the testing above can be done manually, but only some can be done with automated tools.</p>
          <p><strong><em>Build tests</em></strong> are any of the above testing types that have been automated and integrated into your build system.</p>
          <hr />
          <h1 id="a-not-so-crazy-story-">A not-so-crazy story:</h1>
          <p>Bob Sagat, a full-stack developer, is in charge of a new project. His manager is telling him to test the crap out of it. It’s a node/react dashboard. Here is his next 6 months of development:</p>
          <h3 id="phase-1-initial-development-phase">Phase 1: Initial development phase</h3>
          <h4 id="node-api-">Node API:</h4>
          <p>Uses mocha to write <strong><em>Unit</em></strong> tests for controllers, models, services, etc.</p>
          <p>Uses mocha to write <strong><em>Integration</em></strong> tests which calls the endpoints and asserts the response.</p>
          <h4 id="react-">React :</h4>
          <p>Uses jest to write <strong><em>Unit</em></strong> tests for react components.</p>
          <p>Uses selenium to have <strong><em>Integration/functional</em></strong> tests which opens up a browser and pretends to be a user.</p>
          <h3 id="phase-2-almost-about-to-release-">Phase 2: Almost about to release!</h3>
          <p>The QA team starts hammering the project and finds many bugs. As Bob fixes them, his current tests become <strong><em>Regression</em></strong> tests, making sure nothing else is busted.</p>
          <p>The project manager gives a release candidate to some end users (and the CEO) to play with. These are User <strong><em>Acceptance</em></strong> Tests (UAT).</p>
          <h3 id="phase-3-release-">Phase 3: Release!</h3>
          <p>The product is out in the wild. Bob writes a few Selenium tests to <strong><em>Smoke/Sanity</em></strong> check the site, which runs every day at midnight.</p>
          <h1 id="that-s-it-hope-that-helped-">That’s it! hope that helped.</h1>
        </BlogPost>
      </div>
    )
  }

}

export default PostTestTerms;



// WEBPACK FOOTER //
// ./src/pages/blog/post/so-many-testing-terms-so-little-time.js